import { isString as r } from "./chunk326.js";
const i = (t) => {
  if (!r(t)) throw new Error("wrong input type in fn isAbsoluteUrl");
  return /^https?:\/\//i.test(t);
};
export {
  i as isAbsoluteUrl
};
